export default "__VITE_ASSET__lCtFx9ej__"